module.exports = __webpack_public_path__ + "img/car_other_1.393a2cb5.png";